import React, { useState, useEffect } from "react";
import Profile from "./Profile";
import { useAccount } from "wagmi";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";
import { BoxAddress } from "./Contracts/Box";
import { BoxAbi } from "./Contracts/Box";
import { getMagic, getMagic1 } from "./web3";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";
import { FaCopy } from "react-icons/fa";

const Requests = () => {
  const navigate = useNavigate();
  const { data: signer } = useSigner();
  const { BigNumber } = require("ethers");
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [requestedStatus, setRequestedStatus] = useState("");
  const [status, setStatus] = useState(false);
  // const [status, setStatus] = useState(false);

  const { address } = useAccount();
  const token = localStorage.getItem("token");
  console.log("Token", token);

  let userData = JSON.parse(localStorage.getItem("userData"));
  console.log("User", userData);
  let walletAddress = userData?.walletAddress;

  let contract;
  let boxcontract;

  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }
  const RequestedBoxesInfo = async () => {
    console.log("innnnnnnnnnnnnnnn");

    const res = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/all-invite`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data1 = []; // Reset the array before fetching new data

    console.log("dataaaaaa", res);

    await Promise.all(
      res.data.data.map(async (item) => {
        const res2 = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/subscription/${item.boxAddress}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        data1.push({ Box: item, name: res2.data.subscription.name });
      })
    );

    console.log("gfjgsdgfdj", data1);
    setList(data1);
  };

  // const RequestedBoxesInfo = async () => {
  //   console.log("innnnnnnnnnnnnnnn");

  //   const res = await axios.get(
  //     `${process.env.REACT_APP_SERVER_URL}/all-invite`,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );
  //   let data1 = [];
  //   console.log("dataaaaaa", res);
  //   await res.data.data.map(async (item) => {
  //     const res2 = await axios.get(
  //       `${process.env.REACT_APP_SERVER_URL}/subscription/${item.boxAddress}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     data1.push({ Box: item, name: res2.data.subscription.name });
  //   });
  //   console.log("gfjgsdgfdj", data1);
  //   setList(data1);

  //   // console.log("safkjhkjdfdkjhsdf",res2.data.subscription.name)
  // };

  const unlockBox = async (box) => {
    setIsLoading(true);
    let signerr;
    let provider;
    if (localStorage.getItem("isMagic") == "true") {
      console.log("isMagic", localStorage.getItem("isMagic"));

      let [magicSigner, magicProvider] = getMagic1();
      signerr = magicSigner;
      provider = magicProvider;
      console.log("Magicccccccccccccccc", magicSigner, magicProvider);
    } else {
      signerr = signer;
    }
    boxcontract = new ethers.Contract(box, BoxAbi, signerr);
    console.log("Box Contract", boxcontract);
    // await axios
    //     .post(`${process.env.REACT_APP_SERVER_URL}/check-availability`, {
    //       email: email,
    //       boxAddress: box,
    //     })
    //     .then(async (res) => {
    //       console.log("Successfuly ", res.data);
    //       if (res.data.success && res.data.isfirstTime && res.data.attemptLeft>0) {
    let userData = JSON.parse(localStorage.getItem("userData"));

    await boxcontract
      .requestAccessForBox()
      .then(
        async (tx) =>
          await tx.wait().then(async () => {
            await axios
              .post(
                `${process.env.REACT_APP_SERVER_URL}/request-box/`,
                {
                  boxAddress: box,
                  walletAddress: await signerr.getAddress(),
                  email: userData?.email,
                  status: true,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then(async (res) => {
                console.log(res);
                if (res.data.success) {
                  setIsLoading(false);
                  toast.success(
                    "Successfully Requested, You will receive email after approval"
                    
                  );
                  setStatus(!status);
                } else {
                  setIsLoading(false);
                  toast.success("Error !!! please try again later");
                }
              });
          })
      )
      .catch((err) => {
        console.log("error ", err.message);
        setIsLoading(false);
      });
    // } else {
    //   console.log("error ", res);
    //   setIsLoading(false);
    //   toast.success("Already Requested");

    // }
    // } /////////
    // );
  };

  useEffect(() => {
    RequestedBoxesInfo();
  }, [status]);

  console.log("kush", list);
  return (
    <>
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      <div className="antialiased bg-[#212445] w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl  my-10 px-2">
          <Profile />
          <div className=" w-full">
            <h1 className="text-3xl text-white my-10">Requested Boxes</h1>
            {list?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="md:flex md:items-center md:gap-2 lg:gap-4 mt-3 border-b-[1px] w-fit py-2"
                >
                  <div className="">
                    <h1 className="md:my-auto lg:w-[250px] md:w-[150px] w-[300px]">
                      <span className="font-medium">Name:</span>{" "}
                      {item?.name == "" ? "New Box" : item?.name}
                    </h1>
                  </div>

                  <div className=" md:ml-10">
                    {/* <h1 className="my-auto w-[200px]">Box: {item.boxAddress.slice(1,4)+"..."+item.boxAddress.slice(-3,-1)}</h1> */}
                    <h1 className="md:my-auto w-[150px] lg:w-[220px]">
                      <span className="font-medium">Box:</span>
                      {item?.Box?.boxAddress.slice(0, 4) +
                        "..." +
                        item?.Box?.boxAddress.slice(-4)}
                    </h1>
                    {item?.Box?.status != "accepted" &&
                      item?.Box?.attemptLeft > 0 && (
                        <>
                          <h1 className="md:my-auto w-[120px] lg:w-[200px]">
                            <span className="font-medium">Attempts: </span>
                            {item?.Box?.attemptLeft}
                          </h1>
                        </>
                      )}
                  </div>

                  <div className="font-semibold">
                    <div className="md:flex">
                      <button
                        onClick={() => unlockBox(item?.Box?.boxAddress)}
                        disabled={
                          item?.Box?.status == "accepted" ||
                          item?.Box?.status == "pending"
                            ? true
                            : false
                        }
                        className="bg-green-500 p-3 rounded-xl m-2"
                      >
                        {item?.Box?.status == "accepted"
                          ? "Accepted"
                          : item?.Box?.status == "pending"
                          ? "Pending"
                          : "Unlock"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div
          onClick={() => {
            localStorage.setItem("reload", true);
            navigate("/#");
          }}
          className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
        >
          Logout
        </div>
      </div>

      {localStorage.getItem("isMagic") == "false" ? (
        <div className="  px-5 text-white absolute top-2 right-8">
          <ConnectButton className="" />
        </div>
      ) : (
        <div
          onClick={async () => {
            navigator.clipboard.writeText(walletAddress.toString());
          }}
          className=" bg-white rounded-sm flex gap-4 items-center px-5 text-black text-lg cursor-pointer absolute top-2 right-8"
        >
          <FaCopy />
          {localStorage.getItem("walletBalance") > 0.001
            ? localStorage.getItem("walletBalance") + "ETH"
            : "Insufficient Balance"}
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Loading isLoading={isLoading} />
    </>
  );
};

export default Requests;
